// Libraries
import { Table, Popup, EditBin } from '../';
import SearchBinHeader from '../../containers/ManageBin/SearchBinHeader';
import {
    showLoader,
    hideLoader,
} from '../../redux/common/loader/loader.actions';
import {
    searchBinDetailRequest,
    getSearchRecentRequest,
} from '../../containers/ManageBin/redux/manageBin.actions';
import {
    getInitialsEditBin,
    formatTableData,
    getFormattedData,
} from '../../utils/helperMethods';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

// Components

// Actions

// Styles
import './binSearch.scss';

const ManageBinSearchActions = ({ data, fetchData, staticData, resetPage }) => {
    const [showFilter, setShowFilter] = useState(false);
    const [actionType, setActionType] = useState(null);

    const handleOpenActionPopup = actionType => {
        setShowFilter(true);
        setActionType(actionType);
    };

    const handleCloseOpenActionPopup = isFetch => {
        setShowFilter(false);
        setActionType(null);
        if (isFetch && !isFetch.target) {
            fetchData();
        }
    };

    const BinHeadTitle = props => {
        const { binHead } = props.data;
        return (
            <div className="bin-head-title">
                <p className="title-text">Bin Head</p>
                <p>{binHead}</p>
            </div>
        );
    };

    return (
        <div className="userAction  multiItem">
            <button
                className="edit"
                onClick={() => handleOpenActionPopup('EDIT')}
            />
            <Popup
                title={<BinHeadTitle data={data.original} />}
                actionType={actionType}
                showCloseIcon
                showOverlay
                showFilter={showFilter}
                data={data.original}
                closePopup={handleCloseOpenActionPopup}
            >
                <EditBin
                    actionType={actionType}
                    data={data.original}
                    fetchData={fetchData}
                    initialValues={getInitialsEditBin(
                        data.original,
                        staticData
                    )}
                    handleOpenActionPopup={handleOpenActionPopup}
                    closePopup={handleCloseOpenActionPopup}
                />
            </Popup>
        </div>
    );
};

const TableHeadSearch = props => {
    return (
        <div className="mail-head clearfix">
            <div className="headTitle">
                <p>Recent Search</p>
            </div>
        </div>
    );
};

const BinSearch = props => {
    const {
        manageBin,
        staticData,
        actions,
        loader: { showLoader },
    } = props;

    const {
        error,
        tableDataSearch,
        searchedBin,
        isLoading,
        pagination,
    } = manageBin;

    const { searchValue } = useParams();

    // We'll start our table without any data
    const [isResetPage, setIsResetPage] = useState(false);

    const fetchDataSearch = useCallback(() => {
        // This will get called when the table needs new data
        // You could fetch your data from literally anywhere,

        actions.getSearchRecentRequest();
    }, [actions]);

    const getSearchDetails = () => {
        const data = {
            binHead: searchValue,
        };
        actions.searchBinDetailRequest(data);
        fetchDataSearch();
    };

    useEffect(() => {
        if (searchValue) {
            getSearchDetails();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actions, searchValue]);

    const columns = useMemo(
        () => [
            { header: 'Bin Head', accessor: 'binHead' },
            { header: 'Card Type ', accessor: 'cardType' },
            { header: 'Card Nature', accessor: 'cardNature' },
            { header: 'Domestic', accessor: 'isDomestic' },
            { header: 'Issuing Bank', accessor: 'issuingBank' },
            { header: 'EMI Bin', accessor: 'emiBin' },
            { header: 'Bin Block', accessor: 'binBlocked' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const tableData = formatTableData(tableDataSearch, staticData.payValues);

    return (
        <div className="search-bin-wrapper">
            <SearchBinHeader
                data={getFormattedData(
                    searchedBin.values,
                    staticData.payValues
                )}
                error={searchedBin.error}
                userAction={data => (
                    <ManageBinSearchActions
                        data={data}
                        fetchData={getSearchDetails}
                        staticData={staticData.payValues}
                        resetPage={() => setIsResetPage(true)}
                    />
                )}
            />
            <Table
                columns={columns}
                isFiltersEnable
                data={tableData}
                tableHead={<TableHeadSearch />}
                error={error && error.errorMessage}
                loading={showLoader || isLoading}
                fetchData={fetchDataSearch}
                numberOfRecord={pagination.totalNumberOfRecords}
                pagePerView={3}
                isResetPage={isResetPage}
                afterResetPage={() => setIsResetPage(false)}
                userActions={data => (
                    <ManageBinSearchActions
                        data={data}
                        staticData={staticData.payValues}
                        fetchData={getSearchDetails}
                        resetPage={() => setIsResetPage(true)}
                    />
                )}
                tableFilters={null}
            />
        </div>
    );
};

const mapStateToProps = ({ auth, manageBin, loader, staticData }) => ({
    auth,
    manageBin,
    staticData,
    loader,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            hideLoader,
            showLoader,
            searchBinDetailRequest,
            getSearchRecentRequest,
        },
        dispatch
    ),
});

BinSearch.propTypes = {
    actions: PropTypes.object,
    handleSubmit: PropTypes.func,
    closePopup: PropTypes.func,
    data: PropTypes.object,
    roleStatus: PropTypes.string,
    manageBin: PropTypes.object,
    loader: PropTypes.object,
    staticData: PropTypes.object,
};

ManageBinSearchActions.propTypes = {
    data: PropTypes.object,
    staticData: PropTypes.object,
    fetchData: PropTypes.func,
    resetPage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(BinSearch);
